module.exports = __webpack_public_path__ + "img/moni_normal.efa5e17e.png";